module.exports = __webpack_public_path__ + "img/canada-ill-defined-causes-male.18dbfa09.png";